import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=496a702a"
import script from "./Unsubscribe.vue?vue&type=script&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=496a702a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports